import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "reactstrap";
import PlansBenefits from "../PlansBenefits";
import PlanDoc from "../../assets/files/pdfs/plan60.pdf";


import ArrowRightPlans from "../../assets/img/arrow-derecha-planes.svg";
import ArrowRightWhite from "../../assets/img/arrow-blanca.svg";


import Planet from "../../assets/img/planet-earth.svg";
import FirstAid from "../../assets/img/first-aid-kit.svg";
import Patient from "../../assets/img/patient.svg";
import Hospital from "../../assets/img/hospital.svg";
import Pharmacy from "../../assets/img/pharmacy.svg";
import Clipboard from "../../assets/img/clipboard.svg";
import Rehab from "../../assets/img/rehabilitation.svg";
import Payments from "../../assets/img/hand.svg";

const PlanC60 = () => (
  <Container>
    <Row className="mx-0 my-70 justify-content-center">
      <Col xs="12" sm="5">
        <h2 className="mb-4">
          PLAN
          <br />
          C-60 PLUS
        </h2>
        <p className="mb-4 planes__text">
          Cobertura médica prepaga con centros médicos propios en CABA y 
          planes pensados para acompañarte en cada etapa de la vida.

        </p>
        <Link to="/contacto" className="mb-3 btn-big d-block btn-orange">
          Quiero asociarme <img src={ArrowRightWhite} alt="arrow icon" />{" "}
        </Link>
        <a
          href={PlanDoc}
          className="mb-3 btn-big d-block btn-blue-outline"
          download
        >
          Ver plan completo <img src={ArrowRightPlans} alt="arrow icon" />{" "}
        </a>

       
      </Col>


      <Col xs="12" sm={{ size: "4", offset: "1" }}>
        <PlansBenefits iconUrl={Planet}>
          Descuentos en Universal Assistance
        </PlansBenefits>
        <PlansBenefits iconUrl={Payments}>Régimen de copagos</PlansBenefits>
        <PlansBenefits iconUrl={FirstAid}>Consultas médicas</PlansBenefits>
        <PlansBenefits iconUrl={Patient}>Internaciones</PlansBenefits>
        <PlansBenefits iconUrl={Hospital}>
          Emergencias domiciliarias
        </PlansBenefits>
        <PlansBenefits iconUrl={Pharmacy}>Farmacias</PlansBenefits>
        <PlansBenefits iconUrl={Clipboard}>Análisis</PlansBenefits>
        <PlansBenefits iconUrl={Rehab}>Kinesiología</PlansBenefits>
      </Col>
    </Row>
  </Container>
);

export default PlanC60;
